/** Text under the page box in Extract PDF. In Text mode an empty box means "all pages", so the counter says so
 *  instead of keeping the count of the last selection. Returns null when there is nothing to say. */
export function pageCounterText(mode: "pages" | "text", boxText: string, selectedCount: number, pageCount: number): string | null {
  if (mode === "text" && !boxText.trim()) {
    return pageCount > 0 ? `All ${pageCount} page${pageCount === 1 ? "" : "s"} will be read (the page box is empty)` : null;
  }
  if (selectedCount <= 0) return null;
  return `${selectedCount} page${selectedCount === 1 ? "" : "s"} selected${mode === "pages" ? " (kept in the order you typed or in page order)" : ""}`;
}
